import { ActionButton, GetThemeValueForKey, Image, LinearGradient, ViewStyle, YStack } from '@my/ui'
import { ImageProps } from 'react-native/types'

interface GradientButtonProps {
  image: {
    src: ImageProps
    height?: string | number
    width?: string | number
  }
  gradientColors?: string[]
  btnHeight?: number | 'unset' | GetThemeValueForKey<'height'> | null | undefined
  btnWidth?: number | 'unset' | GetThemeValueForKey<'height'> | null | undefined
  shadowProps?: ViewStyle | any
  innerShadowProps?: ViewStyle | any
  gradientStyle?: object
  buttonPressStyle?: object
}

export const GradientButton: React.FC<GradientButtonProps> = ({
  image,
  gradientColors = ['#63995D', '#7BB589', '#85C19D'],
  btnHeight = 40,
  btnWidth = 60,
  shadowProps = {
    shadowColor: '#63995D',
    shadowRadius: 40,
    shadowOffset: { width: 8, height: 8 },
    shadowOpacity: 0.33,
  },
  innerShadowProps = {
    shadowColor: '#FFFFFF',
    shadowRadius: 16,
    shadowOffset: { width: -8, height: -8 },
    shadowOpacity: 1,
  },
  gradientStyle = {
    flex: 1,
    borderRadius: 20,
  },
  buttonPressStyle = {
    opacity: 0.8,
  },
}) => {
  const imageDimensions = {
    width: image.width || 15,
    height: image.height || 15,
  }

  return (
    <YStack space>
      <YStack {...shadowProps}>
        <YStack {...innerShadowProps}>
          <ActionButton
            unstyled
            height={btnHeight}
            width={btnWidth}
            borderRadius="$4"
            overflow="hidden"
            pos="relative"
            pressStyle={buttonPressStyle}
          >
            <LinearGradient
              start={[0, 0]}
              end={[0, 1]}
              colors={gradientColors}
              style={gradientStyle}
            />
            <YStack
              zIndex={1}
              pos="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              alignItems="center"
              justifyContent="center"
            >
              <Image src={image.src} resizeMode="contain" {...imageDimensions} />
            </YStack>
          </ActionButton>
        </YStack>
      </YStack>
    </YStack>
  )
}
